import React from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../../utils/helpers";
import { apiPut } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const Table = ({ requestList, allRequest, page, setDefaultTab, sort, setSort, handleView }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const changeStatus = async (item) => {
    try {
      const payload = {
        status: item?.status,
        employeeID: item?._id,
      };
      const path = `${apiPath.ChangeLeaveStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        setDefaultTab("listing");
        allRequest();
      } else {
        notification.error(result?.data?.message);
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <TableHeaderCell text={t("EMPLOYEE_ID")} />
              <TableHeaderCell text={t("EMPLOYEE_NAME")} />
              <TableHeaderCell text={t("JOB_TITLE")} />
              <TableHeaderCell text={t("DEPARTMENT")} />

              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "officialEmail" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "officialEmail",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "officialEmail",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-left">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "officialEmail" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "officialEmail" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "fromDate" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "fromDate",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "fromDate",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start">
                  <span>{t("FROM_DATE")}</span>
                  <span>
                    {sort.sortBy === "fromDate" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "fromDate" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "toDate" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "toDate",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "toDate",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start">
                  <span>{t("TO_DATE")}</span>
                  <span>
                    {sort.sortBy === "toDate" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "toDate" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <TableHeaderCell text={t("TOTAL_DAYS")} />
              <TableHeaderCell text={t("TYPE")} />
              <TableHeaderCell text={t("OFFERS_DESCRIPTION")} />
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {requestList &&
              requestList?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r">{item?.Employee?.employeeId} </td>
                  <td className="py-4 px-6 border-r">{startCase(item?.Employee?.name)}</td>
                  <td className="py-4 px-6 border-r text-left">{startCase(item?.Job?.name)}</td>
                  <td className="py-4 px-6 border-r text-left">{startCase(item?.Department?.name)}</td>
                  <td className="py-4 px-6 border-r text-left">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}</td>
                  <td className="py-4 px-6 border-r text-left">{dayjs(item?.fromDate).format("MM-DD-YYYY hh:mm A")}</td>
                  <td className="py-4 px-6 border-r text-left">{dayjs(item?.toDate).format("MM-DD-YYYY hh:mm A")}</td>

                  <td className="py-4 px-6 border-r text-left">{item?.noOfDays} </td>
                  <td className="py-4 px-6 border-r text-left">{startCase(item?.leaveType)} </td>
                  <td className="py-4 px-6 border-r text-left">
                    {item?.reason.split(" ").slice(0, 1).join(" ")}.... &nbsp;{" "}
                    <span title="View more" className="text-green-600 cursor-pointer" onClick={() => handleView(item)}>
                      {"view more"}
                    </span>
                  </td>
                  <td className="py-4 px-6 border-l">
                    <div className="">
                      <ul className="flex justify-center items-center">
                        {item?.status === "pending" ? (
                          <>
                            <span title="Accept request" className="text-green-600 cursor-pointer" onClick={() => helper.alertFunction("Are you sure you want to accept employee leave request?", { _id: item?._id, status: "accepted" }, changeStatus)}>
                              {startCase("accept")}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                            <span title="Reject request" className="text-red-600 cursor-pointer" onClick={() => helper.alertFunction("Are you sure you want to reject employee leave request?", { _id: item?._id, status: "rejected" }, changeStatus)}>
                              {startCase("reject")}
                            </span>
                          </>
                        ) : null}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(requestList) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
